import { useIsLockedSpace } from "@circle-react/hooks/useIsLockedSpace";

export const useIsLockedSpaceWithBlocks = () => useIsLockedSpace();
